<template>
  <v-container>
    <h4>Contact Information</h4>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <v-text-field
          v-model="contact_information.phone_number"
          label="Phone number"
          outlined
          dense
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-text-field
          v-model="contact_information.line_id"
          label="Line ID"
          outlined
          dense
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-select
          :items="location_list"
          item-text="label"
          item-value="value"
          label="Address location"
          v-model="contact_information.address_location"
          outlined
          dense
        ></v-select>
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-text-field
          v-model="contact_information.address_sub_district"
          label="Sub-district"
          outlined
          dense
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-text-field
          v-model="contact_information.address_district"
          label="District"
          outlined
          dense
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-text-field
          v-model="contact_information.address_province"
          label="Province/State"
          outlined
          dense
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-text-field
          v-model="contact_information.emergency_contact_person"
          label="Emergency contact person"
          outlined
          dense
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-text-field
          v-model="contact_information.emergency_contact_phone"
          label="Emergency contact phone"
          outlined
          dense
        />
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
import location_list from '../../../json/location_list.json'
export default {
  name: 'ContactInformation',
  components: { },
  props: ['contact_information'],
  data: () => ({
    location_list: location_list,
    rules: {
      require: value => !!value || 'Please fill in information',
      email: eml => !eml || /.+@.+\..+/.test(eml) || "E-mail must be valid",
    }
  }),
  methods: {
  }
}
</script>

<style>
.g-location {
  height: 350px;
  width: auto;
  max-width: 860px;
}
@media (max-width: 767px) {
  .g-location {
    height: 400px;
  }
}
</style>